const ONELINK_BASE = 'https://anyclass.onelink.me/lj9w/0z7a6uck'

/** Строит OneLink; при непустом токене прокидывает бесшовную авторизацию. */
export function buildOneLink (token: string): string {
  const url = new URL(ONELINK_BASE)
  url.searchParams.set('c', 'post_first_day')
  if (token) {
    url.searchParams.set('deep_link_value', 'token')
    url.searchParams.set('deep_link_sub1', token)
  }
  return url.toString()
}
